import * as z from "zod";

const linnworksReturnsLocationTargetSchema = z.object({
  linnworksLocationId: z.string().trim().min(1),
  linnworksLocationName: z.string().trim().optional(),
  // Blank on standard locations; WMS locations require one in the form.
  binrack: z.string().trim(),
});

export const linnworksReturnsSettingsSchema = z.object({
  enabled: z.boolean(),
  processReturnsEnabled: z.boolean(),
  defaultLocation: linnworksReturnsLocationTargetSchema.optional(),
  mappings: z.array(
    linnworksReturnsLocationTargetSchema.extend({
      redoLocationId: z.string().trim().min(1),
    }),
  ),
});
